import React, { Component } from "react";
import { connect } from "react-redux";
import HotKeysModal from "Components/HotKeysModal";
import { updateAreaList, updateBatchSource } from "Store/ZoneSetting/action";
import BatchTable from "./batchTable";
import { langCheck } from "Pub/js/utils";
import SearchBox from './components/SearchBox/WithBatchSetting';
import platform from 'Pub/js/platform';
import { getMultiLangText } from './utilService';
const { NCButton, NCTabs, NCLoading } = platform.base;
const { NCTabPane } = NCTabs;

//批量设置模态框组件类
class BatchSettingModal extends Component {
    constructor(props) {
        super(props);
        this.pageSize = 30; //一次加载多少条数据
        this.currentPage = 1; //当前页数
        this.totalPage = this.getTotalPageSize(this.props.batchSource); //总页数
        this.state = {
            newSource: [],
            searchActives: {},
            searchSelect: {},
            reseek: false,
            tabOptions: [],
            activeKey: '',
            isLoading: false,
        };
        this.batchSource = [];
        this.checkAllCheckedObj = {}; //存放全选checkbox选中状态
    }
    componentDidMount() {
        //这里做一下优化，首次加载默认显示前30条数据，剩余数据通过懒加载加载
        let { newAreaList, areaList, areaIndex, batchSource } = this.props,
            firstBatchSource = batchSource,
            { tabOptions, relations } = this.handleSourceData(newAreaList);
        this.relations = relations;
        this.batchSource = batchSource || [];
        // console.log('tabOptions for', tabOptions, relations);
        this.setState({
            newSource: firstBatchSource,
            tabOptions,
            activeKey: areaList[areaIndex].code || (tabOptions[0] && tabOptions[0].code),
            areatype: areaList[areaIndex].areatype || (tabOptions[0] && tabOptions[0].code),
        });
    }
    //模态框显示时，进行数据初始化
    componentWillReceiveProps(nextProps) {
        if (nextProps.batchSettingModalVisibel !== true) {
            return;
        } else {
            let { batchSource } = nextProps;
            // 理论上来说 这里就不需要更新relations了 不然会导致一些问题
            // this.relations = relations;
            this.batchSource = batchSource;
            // console.log('tabOptions for', tabOptions, relations);
            // this.setState({ newSource: areaList[areaIndex].queryPropertyList }); //old
            //更新三大公式设置的值，只更新已经加载出来的数据
            this.setState({ newSource: batchSource.slice(0, this.state.newSource.length) });
        }
    }

    componentWillUnmount() {
        this.relations = null;
        this.batchSource = null;
    }

    // 为了减少遍历 数据处理 单独提取
    handleSourceData(sourceData = [], tabOptions = [], relations = {}) {
        sourceData.forEach(ele => {
            if (!ele) {
                return;
            }
            // areatype '0'  查询区  '1' 表单区  '2'  表格区
            let { areatype, code, name, groups = [], sides = [], grandsons = [], tabs = [], queryPropertyList, formTabs = [] } = ele;
            const isTabGrandson = grandsons.find(item => item.tabs && item.tabs.length);
            const isFormGroup = formTabs.find(item => item.groups && item.groups.length);
            const grandsonArea = isTabGrandson ? [] : grandsons;
            let localName = getMultiLangText(ele, 'name', this.props.multiOptions);
            tabOptions.push({
                code,
                name: localName,
                areatype,
            });
            relations[code] = {
                code,
                name: localName,
                areatype,
                queryPropertyList,
            };
            [].concat(groups, formTabs, sides, grandsonArea).forEach(item => {
                if (!ele) {
                    return;
                }
                tabOptions.push({
                    code: item.code,
                    // name: item.name,
                    name: getMultiLangText(item, 'name', this.props.multiOptions),
                    areatype: item.areatype,
                });
                relations[item.code] = {
                    code: item.code,
                    // name: item.name,
                    name: getMultiLangText(item, 'name', this.props.multiOptions),
                    areatype: item.areatype,
                    queryPropertyList: item.queryPropertyList,
                };
            });
            if (tabs.length) {
                this.handleSourceData(tabs, tabOptions, relations);
            }
            //孙表多页签
            if (isTabGrandson) {
                this.handleSourceData(grandsons, tabOptions, relations);
            }
            //主表页签分组
            if (isFormGroup) {
                this.handleSourceData(formTabs, tabOptions, relations);
            }
        });
        return { tabOptions, relations };
    }
    //批量设置的模态框的隐藏
    showModalHidden = () => {
        this.props.setModalVisibel(false);
        this.currentPage = 1; //重置当前页数
    };

    //计算分页总页数
    getTotalPageSize = data => Math.ceil(data.length / this.pageSize);

    //点击确定按钮
    onOkDialog = () => {
        let { areaList, areaIndex } = this.props,
            { activeKey } = this.state,
            batchSource = this.batchSource,
            relations = this.relations;
        // 缓存更新之后的数据 以提供给弹窗确定时  保存使用
        this.relations[activeKey].queryPropertyList = batchSource;

        areaList = _.cloneDeep(areaList);
        batchSource = _.cloneDeep(batchSource);
        relations = _.cloneDeep(relations);
        // areaList[areaIndex].queryPropertyList = this.state.newSource; //old
        // 批量更新所有值
        areaList.forEach(item => {
            if (relations[item.code].update) {
                // this.setCheckedByCheckAll(relations[item.code].queryPropertyList); //保存时将checkbox值与全选checkbox值一致
                item.queryPropertyList = relations[item.code].queryPropertyList;
            }
        });
        // console.log(areaList);
        this.props.updateAreaList(areaList);
        this.showModalHidden();
    };
    saveNewSource = (newSource, property, type) => {
        let batchSource = this.batchSource,
            { activeKey } = this.state,
            newBatchSource = newSource.concat(batchSource.slice(newSource.length, batchSource.length));
        // 缓存更新之后的数据 以提供给弹窗确定时  保存使用
        this.relations[activeKey].queryPropertyList = newBatchSource;
        this.relations[activeKey].update = true;
        if (type !== 'formula') { // 公式编辑器不需要这里更新  避免更新地狱
            this.setState({ newSource, reseek: property == 'label' });
            this.props.updateBatchSource(newBatchSource);
        }
    };

    //全选checkbox
    saveAllNewSource = (newSource, property, value) => {
        let batchSource = this.batchSource,
            { activeKey } = this.state,
            newBatchSource = _.cloneDeep(batchSource);
        newBatchSource.map(item => item[property] = value);
        this.setState({ newSource });
        // 缓存更新之后的数据 以提供给弹窗确定时  保存使用
        this.relations[activeKey].queryPropertyList = newBatchSource;
        this.relations[activeKey].update = true;

        this.props.updateBatchSource(newBatchSource);
    }

    //加载下一页批量设置字段
    loadNextPage = () => {
        let { newSource } = this.state;
        let newBatchSource = newSource.concat(this.batchSource.slice(newSource.length, newSource.length + this.pageSize));
        this.setCheckedByCheckAll(newBatchSource); //分页加载的数据checkbox选中状态与全选checkbox一致
        this.setState({ isLoading: true }, () => {
            setTimeout(() => {
                this.aleadyScroll = false;
                this.setState({
                    newSource: newBatchSource,
                    isLoading: false,
                });
            }, 0);
        });
    }

    //监听表格滚动事件
    handleScrollTable = () => {
        let $scrollTable = this.batchTableRef && this.batchTableRef.querySelector(".ant-table-body");
        if (!this.aleadyScroll && $scrollTable && ($scrollTable.scrollTop + $scrollTable.clientHeight >= $scrollTable.scrollHeight * 0.8)) {
            if (this.currentPage < this.totalPage) {
                this.aleadyScroll = true; //加个标示防止重复执行
                this.currentPage++;
                this.loadNextPage();
            }
        }
    }

    //设置checkbox值与全选checkbox一致
    setCheckedByCheckAll = data => {
        for (const [key, { checked, indeterminate }] of Object.entries(this.checkAllCheckedObj)) {
            if (!indeterminate) { //非中间态才赋值
                data.map(item => item[key] = checked);
            }
        }
    }

    /**
     * 查询清空
     */
    onClear = () => {
        this.setState({
            searchActives: {},
            clear: false,
            reseek: false, // 避免无限更新报错
        });
    }

    /**
     * 查询选中
     */
    onSelect = (searchSelect, index = 0) => {
        let { newSource } = this.state,
            batchSource = this.batchSource,
            newBatchSource = newSource;
        if (index > newSource.length - 1) { // 这里会卡顿 是因为一次性加载多页数据导致的
            newBatchSource = newSource.concat(batchSource.slice(newSource.length, index + 1));
            this.setCheckedByCheckAll(newBatchSource); //分页加载的数据checkbox选中状态与全选checkbox一致
        }
        this.setState({
            newSource: newBatchSource,
            searchSelect,
            reseek: false, // 避免无限更新报错
        }, () => {
            let $selected = document.querySelector('.wbs-search-units-selected');
            $selected && $selected.scrollIntoView();
        });
    }
    /**
     * 查询激活
     */
    onActive = searchActives => {
        this.setState({
            searchActives,
            reseek: false, // 避免无限更新报错
        });
    }

    /**
     * 点击tab页签
     */
    onTabChange = currentKey => {
        if (this.state.activeKey == currentKey) {return;}
        let relations = this.relations,
            { areaList } = this.props;
        let { code, areatype, queryPropertyList } = relations[currentKey] ? relations[currentKey] : (areaList.filter(item => item.code == currentKey)[0]);
        this.batchSource = queryPropertyList || [];

        this.currentPage = 1;
        this.totalPage = this.getTotalPageSize(this.batchSource); //重置总页数
        let $scrollTable = this.batchTableRef && this.batchTableRef.querySelector(".ant-table-body");
        if ($scrollTable) {
            $scrollTable.scroll({
                top: 0,
                left: 0,
            });
        }
        this.setState({ isLoading: true }, () => {
            setTimeout(() => {
                this.setState({
                    newSource: this.batchSource,
                    activeKey: currentKey,
                    areatype,
                    clear: true,
                    searchActives: {},
                    searchSelect: {},
                    reseek: false, // 避免searchbox无限更新报错
                    isLoading: false,
                });
                this.props.updateBatchSource(this.batchSource);
            }, 0);
        });
    }

    render() {
        let { json, batchSource, multiOptions } = this.props,
            { newSource, searchActives = {}, searchSelect = {}, reseek, tabOptions = [], activeKey, areatype, clear = false, isLoading = false } = this.state,
            dataSource = this.batchSource || batchSource || [];
        // console.log(activeKey, areatype, dataSource, newSource);
        return (
            <HotKeysModal
                closable={true}
                className="zonesetting-batch-setting-modal"
                style={{ margin: 0 }}
                customTitle={
                    <SearchBox
                        sourceData={[{ code: activeKey, data: dataSource }]}
                        onClear={this.onClear}
                        onSelect={this.onSelect}
                        onActive={this.onActive}
                        searchKey={['label']}
                        reseek={reseek}
                        clear={clear}
                        json={json}
                        multiOptions={multiOptions}
                    />
                }
                onResizeStop={() => {
                    // 弹窗宽度变化时强制更新下
                    this.forceUpdate();
                }}
                title={langCheck(
                    "ZoneSetting-000016",
                    "pages",
                    json,
                )} /* 国际化处理： 批量设置属性*/
                // mask={false}
                maskClosable={false}
                visible={this.props.batchSettingModalVisibel}
                okText={langCheck("ZoneSetting-000005", "pages", json)} /* 国际化处理： 确定*/
                cancelText={langCheck("ZoneSetting-000006", "pages", json)} /* 国际化处理： 取消*/
                onOk={this.onOkDialog}
                onCancel={this.showModalHidden}
                destroyOnClose={true}
                width="98%"
                height={`${document.body.clientHeight - 150}px`}
                fieldid="batchSetting"
            >
                <div
                    type="ncdiv"
                    fieldid="batchSetting_table" //自动化测试标记
                    ref={ref => this.batchTableRef = ref}
                    onScrollCapture={this.handleScrollTable}
                    style={{ height: '100%' }}
                >
                    <NCTabs
                        activeKey={activeKey}
                        className="batch-setting-tabs"
                        tabBarStyle="simple"
                        onChange={this.onTabChange}
                        onPrevClick={e => {
                            // console.log('onPrevClick', e);
                        }}
                        onNextClick={e => {
                            // console.log('onNextClick', e);
                        }}
                    >
                        {tabOptions.map(item => {
                            return (
                                <NCTabPane tab={item.name} key={item.code}>
                                    {/* 不渲染内容  所有加载为懒加载 */}
                                    {
                                        item.code === activeKey && (
                                            <React.Fragment>
                                                <BatchTable
                                                    newSource={newSource}
                                                    batchSource={this.batchSource}
                                                    searchActives={searchActives[activeKey]}
                                                    searchSelect={searchSelect[activeKey]}
                                                    areatype={areatype}
                                                    saveNewSource={this.saveNewSource}
                                                    saveAllNewSource={this.saveAllNewSource}
                                                    forwardRef={(key, value) => this.checkAllCheckedObj[key] = value}
                                                    multiOptions={multiOptions}
                                                />
                                            </React.Fragment>
                                        )
                                    }
                                </NCTabPane>
                            );
                        })}
                    </NCTabs>
                    {
                        <NCLoading container={this} show={isLoading} />
                    }
                </div>
            </HotKeysModal>
        );
    }
}
export default connect(
    state => ({
        areaList: state.zoneSettingData.areaList,
        batchSource: state.zoneSettingData.batchSource,
        newAreaList: state.zoneSettingData.newAreaList,
    }),
    {
        updateAreaList,
        updateBatchSource,
    },
)(BatchSettingModal);
